/** Only one well-formed transaction reference is accepted; it is not authority. */
export function paddlePaymentLinkTransaction(search: string): string | null {
  const values = new URLSearchParams(search).getAll("_ptxn");
  return values.length === 1 && /^txn_[a-z0-9]{26}$/.test(values[0]) ? values[0] : null;
}

/** Prevent Paddle.js's URL-driven auto-open from bypassing our owned bootstrap. */
export function withoutPaddleTransaction(href: string): string {
  const url = new URL(href);
  url.searchParams.delete("_ptxn");
  return `${url.pathname}${url.search}${url.hash}`;
}
